module.exports = __webpack_public_path__ + "static/media/CRYSTL.6b4c423f.png";